import { observable, action, computed, set, intercept } from "mobx";
import { post } from "../services/ajax.service";

class CostPlusStore {
  @observable cost_plus_card = {};
  @observable cost_plus_list = [];
  @observable url = "/api/v1/recommendationactions/CostPlus";


  
  @action getCostPlus = async (data) => {
    this.cost_plus_card = {};
    try {
      let response = await post(
        `${this.url}/getCostPlus`,
        data
      );

      const {TARGET_SPEND,drug_count,potential_spend,unique_par}=response.data[0];

      this.cost_plus_card = {target_spend:TARGET_SPEND,potential_spend,drug_count:this.getUniqueArraySize(drug_count),participants_count:this.getUniqueArraySize(unique_par)};
    } catch (err) {
      console.log(err);
    }
  }

  @action getDrugSpend = async (data) => {
    this.cost_plus_list = [];
    try {
      let response = await post(
        `${this.url}/getDrugSpend`,
        data
      );

      this.cost_plus_list = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  getUniqueArraySize=(value)=>{
    if(!value){
      return 0;
    }
    const uniqueSet = new Set(value?.split(",").filter(Boolean));
    // Convert the Set back to an array
    const uniqueArray = Array.from(uniqueSet);
    return uniqueArray?.length;
  }
}

export default CostPlusStore;
